export const fontConfig = {
  web: {
    regular: {
      fontFamily: 'Montserrat, "Helvetica Neue", Helvetica, Arial, sans-serif',
      fontWeight: "400" as "400",
    },
    medium: {
      fontFamily: 'Montserrat-Medium, "Helvetica Neue", Helvetica, Arial, sans-serif',
      fontWeight: "500" as "500",
    },
    light: {
      fontFamily: 'Montserrat-Light, "Helvetica Neue", Helvetica, Arial, sans-serif',
      fontWeight: "300" as "300",
    },
    thin: {
      fontFamily: 'Montserrat-Thin, "Helvetica Neue", Helvetica, Arial, sans-serif',
      fontWeight: "100" as "100",
    },
    semibold: {
      fontFamily: 'Montserrat-SemiBold, "Helvetica Neue", Helvetica, Arial, sans-serif',
      fontWeight: "600" as "600",
    },
    bold: {
      fontFamily: 'Montserrat-Bold, "Helvetica Neue", Helvetica, Arial, sans-serif',
      fontWeight: "700" as "700",
    },
    card: {
      fontFamily: 'Card-Fonts, "Helvetica Neue", Helvetica, Arial, sans-serif',
      fontWeight: "700" as "700",
    },
  },
  ios: {
    regular: {
      fontFamily: "Montserrat",
      fontWeight: "400" as "400",
    },
    medium: {
      fontFamily: "Montserrat-Medium",
      fontWeight: "500" as "500",
    },
    light: {
      fontFamily: "Montserrat-Light",
      fontWeight: "300" as "300",
    },
    thin: {
      fontFamily: "Montserrat-Thin",
      fontWeight: "100" as "100",
    },
    semibold: {
      fontFamily: 'Montserrat-SemiBold, "Helvetica Neue", Helvetica, Arial, sans-serif',
      fontWeight: "600" as "600",
    },
    bold: {
      fontFamily: "Montserrat-Bold",
      fontWeight: "700" as "700",
    },
    card: {
      fontFamily: "Card-Fonts",
      fontWeight: "700" as "700",
    },
  },
  default: {
    regular: {
      fontFamily: "Montserrat",
      fontWeight: "normal" as "normal",
    },
    medium: {
      fontFamily: "Montserrat-Medium",
      fontWeight: "normal" as "normal",
    },
    light: {
      fontFamily: "Montserrat-Light",
      fontWeight: "normal" as "normal",
    },
    thin: {
      fontFamily: "Montserrat-Thin",
      fontWeight: "normal" as "normal",
    },
    semibold: {
      fontFamily: 'Montserrat-SemiBold, "Helvetica Neue", Helvetica, Arial, sans-serif',
      fontWeight: "normal" as "normal",
    },
    bold: {
      fontFamily: "Montserrat-Bold",
      fontWeight: "normal" as "normal",
    },
    card: {
      fontFamily: "Card-Fonts",
      fontWeight: "normal" as "normal",
    },
  },
};
